export interface AccountChildrenOption {
  channel: string;
  account: string;
  value: string;
}

export interface AccountOption {
  text: string;
  value: string;
  children: AccountChildrenOption[];
}

export function getAccountListValue(options: AccountOption[]) {
  const values: string[] = [];
  options.forEach(option => {
    option.children.forEach(child => {
      values.push(child.value);
    });
  });
  return values;
}

export function getAccountList(options: AccountOption[], value: string[]) {
  const list: AccountChildrenOption[] = [];
  options.forEach(option => {
    option.children.forEach(child => {
      if (value.includes(child.value)) {
        list.push(child);
      }
    });
  });
  return list;
}
